import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import Video, {
  createLocalAudioTrack,
  createLocalVideoTrack,
  createLocalTracks,
} from "twilio-video";
import { getVideoToken } from "../../../api";
import Room from "./Room";
import "./video.css";
import LoadingComponent from "../../../Components/LoadingComponent";

const VideoChat = () => {
  const { user } = useSelector((state) => state.auth);
  const role = user?.user?.role;

  const queryUrl = new URLSearchParams(useLocation().search);

  const roomId = queryUrl.get("roomId");

  const userName = queryUrl.get("name");
  const callType = queryUrl.get("callType");

  const [room, setRoom] = useState(null);
  const [connecting, setConnecting] = useState(false);

  let tracks = [];
  useEffect(() => {
    tracks = [];
    const connectVideo = async () => {
      setConnecting(true);
      try {
        const response = await getVideoToken({ roomId, userName });
        console.log(response.data.token);
        try {
          const audioTrack = await createLocalAudioTrack();
          // console.log(audioTrack, "Audio track");
          tracks.push(audioTrack);
        } catch (error) {
          console.log("Failed Media:", error.name, error.message);
        }

        try {
          const videoTrack = await createLocalVideoTrack();
          // console.log(videoTrack, "videoTrack");
          tracks.push(videoTrack);
        } catch (error) {
          console.log("Failed Media:", error.name, error.message);
        }

        console.log(tracks, "tracks");

        Video.connect(response.data.token, {
          name: roomId,
          tracks: tracks,
        })
          .then((room) => {
            console.log(room);
            setConnecting(false);
            setRoom(room);
          })
          .catch((error) => {
            console.error("Failed to connect to the video room:", error);
            setConnecting(false);
          });
      } catch (error) {
        console.error(error);
        setConnecting(false);
      }
    };

    connectVideo();
  }, [roomId, userName]);

  const handleLogout = useCallback(async () => {
    setRoom((prevRoom) => {
      if (prevRoom) {
        prevRoom.localParticipant.tracks.forEach((trackPub) => {
          trackPub.track.stop();
        });
        prevRoom.disconnect();
      }
      return null;
    });

    window.location = "/dashboard";
    // try {
    //   await updateBooking({ id: roomId, status: "conpleted" });
    // } catch (error) {
    //   console.log(error);
    // }
    // history.push(
    //   role === "doctor"
    //     ? "/dashboard/consulation"
    //     : `/dashboard/consulation?review=true&&bookingId=${roomId}`
    // );
  }, []);

  useEffect(() => {
    if (room) {
      const tidyUp = (event) => {
        if (event.persisted) {
          return;
        }
        if (room) {
          // handleLogout();
        }
      };
      window.addEventListener("pagehide", tidyUp);
      window.addEventListener("beforeunload", tidyUp);
      return () => {
        window.removeEventListener("pagehide", tidyUp);
        window.removeEventListener("beforeunload", tidyUp);
      };
    }
  }, [room, handleLogout]);

  console.log(room);

  return (
    <>
      {room ? (
        <Room
          userId={userName}
          roomName={roomId}
          callType={callType}
          room={room}
          tracks={tracks}
          handleLogout={handleLogout}
          role={role}
        />
      ) : (
        <LoadingComponent />
      )}
    </>
  );

  // return <h1>Helo</h1>;
};

export default VideoChat;
